import { FC, PropsWithChildren } from 'react'

import { useRouterExtend } from 'hooks/useRouterExtend'
import { DISABLED_AD_BY_LOCALE } from 'interfaces/constants/ads'

export type AdBlockContainerProps = {
  // TODO
}
export const AdBlockContainer: FC<PropsWithChildren<AdBlockContainerProps>> = ({
  children,
}) => {
  const { locale } = useRouterExtend()
  const disabledByLocale = DISABLED_AD_BY_LOCALE?.includes(locale)
  if (disabledByLocale) {
    return null
  }
  return <>{children}</>
}
